
import {  ChangeDetectorRef, Component, EventEmitter, HostListener, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder,  UntypedFormGroup, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isMoment } from 'moment';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { FilterParam } from 'src/app/interfaces/filter-param';
import { FormServices } from 'src/app/services/form.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

@Component({
    selector: 'prompt-filter-view',
    templateUrl: './prompt-filter-view.component.html',
    styleUrls: ['./prompt-filter-view.component.scss'],
    standalone: false
})
export class PromptFilterViewComponent implements OnInit,OnChanges {

  @Input('expressao') expressao:string = null;
  @Input('showcard') showCard = true;
  @Input('form') form:FormGroup;
  @Input('showbuscadados')showBuscaDados:boolean = true;
  parameters:columnsDef[] = [];
  selectedValue =[];
  @Input('lastFilter') lastFilter:Object;
  /** emitido no Enter quando o componente está em uso INLINE (form via @Input) */
  @Output() apply = new EventEmitter<void>();
  title = "Parâmetros de Filtro";
  @HostListener('keyup', ['$event'])
  public onKeyUp(event: KeyboardEvent): void {

    if (event.code =='Enter'  ) {
      if ( this.isInline() ){
        // uso inline (ex.: painel de filtro do dashboard): aplicar o filtro,
        // nunca fechar dialog (o MatDialogRef aqui é o fake global {})
        this.apply.emit();
      }else{
        this.ok();
      }
    }
  }

  /** inline = form fornecido pelo pai; dialog = aberto via MatDialog */
  private isInline(): boolean {
    return this.form != null || typeof this.dialogRef?.close !== 'function';
  }

  constructor(private fb:UntypedFormBuilder,@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>, private fs:FormServices,public cd: ChangeDetectorRef ) {      
      
   }
  
   ngOnChanges(changes: SimpleChanges): void {
    if (changes.lastFilter!=null && changes.lastFilter.currentValue != null && changes.lastFilter.currentValue!=changes.lastFilter.previousValue ){
      this.applyLastFilter(JSON.parse(changes.lastFilter.currentValue) as object);
    }
  }

  formGroup:UntypedFormGroup;

  ngOnInit(): void {

      if ( this.form != null ){
        this.formGroup = this.form;
      }else{
        this.formGroup = this.fb.group({});
        this.expressao = this.data.data;
        this.lastFilter = this.data.lastFilter;
      }

      if ( this.data.title != null ){
        this.title = this.data.title;
      }

      if ( this.expressao != null ){
          var matchs = null;
          if (!ObjectUtil.isNotEmpty(this.data) || this.data.useParamFilter) {
            // this.expressao may be a JSON array string or a single JSON string
            if (this.expressao == null) {
              matchs = [];
            } else if (typeof this.expressao === 'string') {
              // Try parsing as a JSON array first
              try {
                const parsed = JSON.parse(this.expressao);
                // If parsed is an array of objects, use it directly
                if (Array.isArray(parsed)) {
                  matchs = parsed as FilterParam[];
                } else if (typeof parsed === 'object') {
                  // single object wrapped
                  matchs = [parsed] as FilterParam[];
                } else {
                  // fallback to extracting JSON-like fragments from template
                  const extracted = ObjectUtil.extracJson(this.expressao);
                  matchs = extracted.map(s => {
                    try { return JSON.parse(s); } catch { return s; }
                  }) as FilterParam[];
                }
              } catch (e) {
                // Not a plain JSON string — extract JSON fragments from template
                const extracted = ObjectUtil.extracJson(this.expressao);
                matchs = extracted.map(s => {
                  try { return JSON.parse(s); } catch { return s; }
                }) as FilterParam[];
              }
            } else {
              // expressao already an object/array
              matchs = this.expressao as any as FilterParam[];
            }
          } else {
            matchs = ObjectUtil.extracJson(this.expressao);
          }
        
        
        var i:number = 1;
        matchs.forEach(r=>{
          var filterparam:FilterParam = !ObjectUtil.isNotEmpty(this.data) || this.data.useParamFilter ? r : JSON.parse(r);
          var dataType  = "";
          switch ( filterparam.tipo.toUpperCase() ){
             case "S" :{  dataType = "VARCHAR"; break;}
             case "D" :{ dataType = "DATETIME"; break;}
             case "N" :{ dataType = "FLOAT"; break;}
             case "I" :{ dataType = "INT"; break;}
             case "L" :{ dataType = "SELECT"; break;}
             case "R" :{ dataType = "SEARCHREFERENCE"; break;}
             default :{dataType = "VARCHAR"}
          }
 
          var validationError = ''
          if ( dataType =="SELECT"){
              let ob = {
                  'type':'select',
                  'options':filterparam.lista
              }
              validationError = JSON.stringify(ob);
          }

          var columnDef:columnsDef = {
             DATATYPE:dataType,
             COLUMNDESC:filterparam.desc,
             COLUMNNAME:filterparam.nome,
             PLACEHOLDER:filterparam.nome,
             IDCOLUMN:i,
             ISIDENTITY:0,
             ISREQUIRED:1,
             VISIBLE:1,
             LINE:0,
             CELL:0,
             tab:'sem tab',
             REFERENCES:[],
             VALIDATIONERROR:validationError
            }

            if ( dataType == "SEARCHREFERENCE" ){
              columnDef.COLUMNDESC =  filterparam.desc;
              columnDef.COLUMNNAME =  filterparam.controlName + "->"+ filterparam.apresentationField;
              columnDef.PLACEHOLDER = filterparam.desc;
              columnDef.refName= filterparam.controlName;
              columnDef.headerName = filterparam.nome;
              columnDef.REFERENCES= [{
                CONSTRAINT_COLUMN_REF:filterparam.controlName + "->"+ filterparam.apresentationField,
                CONSTRAINT_NAME:filterparam.controlName + "->"+ filterparam.apresentationField
              }]
              columnDef.ISFK = 1;
              //columnDef.headerName = filterparam.nome;
              let ob={
                  RefName: filterparam.entityName,
                  RefDesc: filterparam.entityDesc
              }
              columnDef.VALIDATIONERROR = JSON.stringify(ob);
            }

            this.parameters.push(columnDef);

            i++;  
        })
        
        this.fs.refreshForm(this.formGroup,this.parameters,{},false);

        this.applyLastFilter(null);
    }
 
  }

  applyLastFilter(lastFilter:object){
    let filter:object = lastFilter == null ? this.lastFilter : lastFilter;
    
    if ( filter != null ){
      if (typeof filter === 'string') {
        filter = JSON.parse(filter);
      }

      Object.keys(filter).forEach(value=>{
        try{
          if (this.formGroup == null ){
            this.formGroup = this.form;
          }
          this.formGroup.get(value).patchValue(filter[value]);
        } catch(Exception){
            
        }  
      });
    }
  }
  
  cancelar(){
    if ( typeof this.dialogRef?.close !== 'function' ){
      return;
    }
    this.dialogRef.close();
  }

  ok(){
    if ( typeof this.dialogRef?.close !== 'function' ){
      this.apply.emit();
      return;
    }
    if ( this.formGroup.valid ){
      if ( this.data!=null && this.data.useParamFilter!=null && this.data.useParamFilter){
        this.dialogRef.close(JSON.stringify({expressao: this.expressao, group: this.formGroup.getRawValue()}));
      }else{
        this.treatingStrings();
        this.dialogRef.close(JSON.stringify({expressao: this.expressao, group: this.formGroup.getRawValue()}));
      }
    }else{
      this.formGroup.markAllAsTouched();
    }
    
  }


  treatingStrings() {
    if ( this.expressao != null ){

      var matchs = ObjectUtil.extracJson(this.expressao);
 
      var i:number = 1;
      matchs.forEach(r=>{
        var filterparam:FilterParam =  JSON.parse(r);
        var value = this.formGroup.get(filterparam.nome).value;
        if ( isMoment(value) ){
          value = value.toJSON();
        }
        this.expressao = this.expressao.replace(r,value).trim();
      });
    }
  }
}
